module.exports = __webpack_public_path__ + "static/media/undraw_Speed_test_re_pe1f.0da523d5.png";